import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.trim.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import { login, logout, getUserInfo } from '@/api/users';
import { getToken, setToken as _setToken, removeToken } from '@/utils/sessionStorage';
import router, { resetRouter } from '@/router';
import { PermissionModule } from './permission';
import { TagsViewModule } from './tags-view';
import store from '@/store';
var User = /*#__PURE__*/function (_VuexModule) {
  function User() {
    var _this;
    _classCallCheck(this, User);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, User, [].concat(args));
    _defineProperty(_this, "token", getToken() || {});
    _defineProperty(_this, "name", '');
    _defineProperty(_this, "avatar", '');
    _defineProperty(_this, "introduction", '');
    _defineProperty(_this, "roles", []);
    _defineProperty(_this, "email", '');
    return _this;
  }
  _inherits(User, _VuexModule);
  return _createClass(User, [{
    key: "SET_TOKEN",
    value: function SET_TOKEN(token) {
      this.token = token;
    }
  }, {
    key: "SET_NAME",
    value: function SET_NAME(name) {
      this.name = name;
    }
  }, {
    key: "SET_AVATAR",
    value: function SET_AVATAR(avatar) {
      this.avatar = avatar;
    }
  }, {
    key: "SET_INTRODUCTION",
    value: function SET_INTRODUCTION(introduction) {
      this.introduction = introduction;
    }
  }, {
    key: "SET_ROLES",
    value: function SET_ROLES(roles) {
      this.roles = roles;
    }
  }, {
    key: "SET_EMAIL",
    value: function SET_EMAIL(email) {
      this.email = email;
    }
  }, {
    key: "setToken",
    value: function () {
      var _setToken2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(token) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _setToken(token);
              this.SET_TOKEN(token);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function setToken(_x) {
        return _setToken2.apply(this, arguments);
      }
      return setToken;
    }()
  }, {
    key: "Login",
    value: function () {
      var _Login = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(userInfo) {
        var username, password, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              username = userInfo.username, password = userInfo.password;
              username = username.trim();
              _context2.n = 1;
              return login({
                username: username,
                password: password,
                response_type: 'code',
                client_id: 'browser',
                grant_type: 'password',
                scope: 'ui'
              });
            case 1:
              res = _context2.v;
              this.setToken(res);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function Login(_x2) {
        return _Login.apply(this, arguments);
      }
      return Login;
    }()
  }, {
    key: "ResetToken",
    value: function ResetToken() {
      removeToken();
      this.SET_TOKEN({});
      this.SET_ROLES([]);
    }
  }, {
    key: "GetUserInfo",
    value: function () {
      var _GetUserInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var token, user, roles, name, email;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              token = getToken();
              if (!(Object.keys(token).length === 0 && JSON.stringify(token) === JSON.stringify({}))) {
                _context3.n = 1;
                break;
              }
              throw Error('GetUserInfo: token is undefined!');
            case 1:
              _context3.n = 2;
              return getUserInfo({
                /* Your params here */
              });
            case 2:
              user = _context3.v;
              if (user) {
                _context3.n = 3;
                break;
              }
              throw Error('Verification failed, please Login again.');
            case 3:
              roles = user.roles, name = user.name, email = user.email; // roles must be a non-empty array
              if (!(!roles || roles.length <= 0)) {
                _context3.n = 4;
                break;
              }
              throw Error('GetUserInfo: roles must be a non-null array!');
            case 4:
              this.SET_ROLES(roles);
              this.SET_NAME(name);
              this.SET_AVATAR('/img/logo.svg');
              // this.SET_INTRODUCTION(introduction)
              this.SET_EMAIL(email);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function GetUserInfo() {
        return _GetUserInfo.apply(this, arguments);
      }
      return GetUserInfo;
    }()
  }, {
    key: "ChangeRoles",
    value: function () {
      var _ChangeRoles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(role) {
        var token;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              // Dynamically modify permissions
              token = role + '-token'; // this.SET_TOKEN(token)
              // setToken(token)
              _context4.n = 1;
              return this.GetUserInfo();
            case 1:
              resetRouter();
              // Generate dynamic accessible routes based on roles
              PermissionModule.GenerateRoutes(this.roles);
              // Add generated routes
              router.addRoutes(PermissionModule.dynamicRoutes);
              // Reset visited views and cached views
              TagsViewModule.delAllViews();
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function ChangeRoles(_x3) {
        return _ChangeRoles.apply(this, arguments);
      }
      return ChangeRoles;
    }()
  }, {
    key: "LogOut",
    value: function () {
      var _LogOut = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(this.token === '')) {
                _context5.n = 1;
                break;
              }
              throw Error('LogOut: token is undefined!');
            case 1:
              _context5.n = 2;
              return logout();
            case 2:
              removeToken();
              resetRouter();
              this.SET_TOKEN({});
              this.SET_ROLES([]);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function LogOut() {
        return _LogOut.apply(this, arguments);
      }
      return LogOut;
    }()
  }]);
}(VuexModule);
__decorate([Mutation], User.prototype, "SET_TOKEN", null);
__decorate([Mutation], User.prototype, "SET_NAME", null);
__decorate([Mutation], User.prototype, "SET_AVATAR", null);
__decorate([Mutation], User.prototype, "SET_INTRODUCTION", null);
__decorate([Mutation], User.prototype, "SET_ROLES", null);
__decorate([Mutation], User.prototype, "SET_EMAIL", null);
__decorate([Action({
  rawError: true
})], User.prototype, "setToken", null);
__decorate([Action({
  rawError: true
})], User.prototype, "Login", null);
__decorate([Action], User.prototype, "ResetToken", null);
__decorate([Action], User.prototype, "GetUserInfo", null);
__decorate([Action], User.prototype, "ChangeRoles", null);
__decorate([Action], User.prototype, "LogOut", null);
User = __decorate([Module({
  dynamic: true,
  store: store,
  name: 'user'
})], User);
export var UserModule = getModule(User);